export default __webpack_public_path__ + "static/media/cpp.2441702d.svg";